import {
    ADD_ROLE,
    GET_ROLE,
    ALL_ROLE,
    EDIT_ROLE,
  } from "./actionTypes"
  
  export const addRoles = (role,history) => {
    return {
      type: ADD_ROLE,
      payload: { role,history},
    }
  }

  export const getRoles = (role) => {
    return {
      type: GET_ROLE,
      payload: { role},
    }
  }

  export const allRoles = role => {
    return {
      type: ALL_ROLE,
      payload: role,
    }
  }

  export const editRoles =  (role,history) => {
    return {
      type: EDIT_ROLE,
      payload: { role,history},
    }
  }

  